import { render, staticRenderFns } from "./AssignCro.vue?vue&type=template&id=846e22e6&scoped=true"
import script from "./AssignCro.vue?vue&type=script&lang=js"
export * from "./AssignCro.vue?vue&type=script&lang=js"
import style0 from "./AssignCro.vue?vue&type=style&index=0&id=846e22e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "846e22e6",
  null
  
)

export default component.exports